module.exports = __webpack_public_path__ + "static/media/hbb_grid_8.126529d9.png";